import { c as _c } from "react/compiler-runtime";
import { Button, StackProps, VStack, Wrap, Field } from '@chakra-ui/react';
import { ScoTagComboboxInput } from '@src/components/sco/ScoTagComboboxInput';
import { SelectableButtons } from '@src/components/sco/SelectableButtons';
import { compensationTypes } from '@src/constants/compensation-types';
import { groupRequestTypes } from '@src/constants/group-request-types';
import { parseAsArrayOf, parseAsString, useQueryState } from 'nuqs';
import React from 'react';
type RequestSidebarFilterFormProps = {
  stackProps?: StackProps;
};
export const RequestSidebarFilterForm: React.FC<RequestSidebarFilterFormProps> = props => {
  const $ = _c(23);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = parseAsArrayOf(parseAsString);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [, setRequestTypeKeys] = useQueryState("requestTypeKeys", t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = parseAsArrayOf(parseAsString);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [, setCompensationTypeKeys] = useQueryState("compensationTypeKeys", t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = parseAsArrayOf(parseAsString);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [, setTagTitles] = useQueryState("tagTitles", t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Field.Label textStyle="label2xs">Request Type</Field.Label>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [];
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      buttonProps: {
        fontSize: "xs",
        paddingY: 1,
        paddingX: 2,
        flexGrow: 1
      },
      inactiveColor: "colorPalette.subtle/50",
      activeColor: "colorPalette.solid"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== setRequestTypeKeys) {
    t6 = <Field.Root>{t3}<Wrap gap={1}><SelectableButtons defaultEmptyOption={true} defaultValue={t4} options={groupRequestTypes} selectableButtonProps={t5} onChange={selections => setRequestTypeKeys(selections.length ? selections.map(_temp) : null)} /></Wrap></Field.Root>;
    $[6] = setRequestTypeKeys;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Field.Label textStyle="label2xs">Skills, Industries, Tags</Field.Label>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      inputProps: {
        size: "sm",
        variant: "subtle"
      }
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== setTagTitles) {
    t9 = <Field.Root>{t7}<ScoTagComboboxInput comboboxTagInputProps={t8} onSelectedTagsChange={selectedTags => setTagTitles(selectedTags.length ? selectedTags.map(_temp2) : null)} /></Field.Root>;
    $[10] = setTagTitles;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Field.Label textStyle="label2xs">Compensation Type</Field.Label>;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = [];
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      buttonProps: {
        size: "xs",
        paddingY: 1,
        flexGrow: 1
      },
      inactiveColor: "colorPalette.subtle/50",
      activeColor: "colorPalette.solid"
    };
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== setCompensationTypeKeys) {
    t13 = <Field.Root>{t10}<Wrap gap={1}><SelectableButtons defaultEmptyOption={true} defaultValue={t11} options={compensationTypes} selectableButtonProps={t12} onChange={selections_0 => setCompensationTypeKeys(selections_0.length ? selections_0.map(_temp3) : null)} /></Wrap></Field.Root>;
    $[15] = setCompensationTypeKeys;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <VStack align="stretch" gap={1}><Button size="sm" variant="outline">Reset Filters</Button></VStack>;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== props.stackProps || $[19] !== t13 || $[20] !== t6 || $[21] !== t9) {
    t15 = <VStack align="stretch" {...props.stackProps} gap={6}>{t6}{t9}{t13}{t14}</VStack>;
    $[18] = props.stackProps;
    $[19] = t13;
    $[20] = t6;
    $[21] = t9;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  return t15;
};
function _temp(s) {
  return s.key;
}
function _temp2(t) {
  return t.title;
}
function _temp3(s_0) {
  return s_0.key;
}